import React from "react";
import { MoonStars } from "@phosphor-icons/react";

const LINE = { sales: "Ventas", service: "Servicio", parts: "Piezas", financing: "Financiamiento", bdc: "Atención al cliente", supervisor: "Supervisión" };

export const AfterHoursContactCard = ({ data }) => {
  const fields = [
    ["Nombre", [data.name, data.last_name].filter(Boolean).join(" ")],
    ["Teléfono", data.phone],
    ["Correo", data.email],
    ["Línea", LINE[data.target] || data.target],
  ];
  return (
    <div className="mx-4 mt-3 rounded-lg border border-amber-500/40 bg-amber-500/10 p-3" data-testid="after-hours-contact-card">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-amber-700 dark:text-amber-400 mb-2">
        <MoonStars size={14} weight="duotone" /> Contacto fuera de horario
        <span className="normal-case tracking-normal font-normal text-muted-foreground" data-testid="after-hours-holiday">· {data.holiday}</span>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
        {fields.map(([label, value]) => (
          <div key={label} className="min-w-0" data-testid={`after-hours-${label.toLowerCase()}`}>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
            <div className="text-sm break-words">{value || <span className="text-muted-foreground italic">pendiente</span>}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
